import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import CharacterQuote from '../characters/CharacterQuote';

const ModuleSummary = ({ points = [], characterId, nextPreview }) => {
  return (
    <div className="mt-10 space-y-6">
      {/* Key Takeaways */}
      <div className="bg-gradient-to-br from-courtyard-olive/10 to-courtyard-olive/5 border border-courtyard-olive/20 rounded-2xl p-6 shadow-sm">
        <h3 className="font-display text-lg font-bold text-courtyard-stone mb-5 flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-courtyard-olive/20 flex items-center justify-center">
            <CheckCircle className="w-4.5 h-4.5 text-courtyard-olive-dark" aria-hidden="true" />
          </div>
          Key Takeaways
        </h3>
        <ul className="space-y-3">
          {points.map((point, i) => (
            <li key={i} className="flex gap-3 text-[15px] text-courtyard-stone/80">
              <CheckCircle className="w-5 h-5 text-courtyard-olive-dark flex-shrink-0 mt-0.5" aria-hidden="true" />
              <span className="leading-relaxed">{point}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Coming Next */}
      {nextPreview && (
        <div className="bg-gradient-to-br from-courtyard-gold/10 to-courtyard-terracotta/10 border border-courtyard-gold/20 rounded-2xl p-6 shadow-sm">
          <h3 className="font-display text-lg font-bold text-courtyard-stone mb-4 flex items-center gap-2">
            <ArrowRight className="w-5 h-5 text-courtyard-clay" aria-hidden="true" />
            Coming Next
          </h3>
          {nextPreview.dialogue?.map((line, i) => (
            <CharacterQuote
              key={i}
              characterId={line.character}
              quote={line.text}
              className="mb-3"
            />
          ))}
          {nextPreview.text && (
            <p className="text-sm text-courtyard-stone/80 italic mt-3">{nextPreview.text}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ModuleSummary;
